module.exports = __webpack_public_path__ + "img/problemTop.ec420231.png";